more.search = {
    // Funkcia na obsluhu rucneho vyhladania eventu a oddu
    sCalc(value) {
        try {
            switch (value) {
                case "backspace":
                    stored.sCalcID = stored.sCalcID.slice(0, -1);
                    if (!stored.sCalcID.length) {
                        $("#searchDisplay").removeAttr("class").html(texts.ManualCalcTipEvent);
                    } else {
                        if (sets.lengthOddID.includes(stored.sCalcID.length) || stored.sCalcID.length === sets.lengthEventID || stored.sCalcID.length === sets.lengthStoredTicketShortID) {
                            if (stored.sCalcID.length === sets.lengthEventID || stored.sCalcID.length === sets.lengthStoredTicketShortID) {
                                // Zobrazit (detail zapasu, ulozeny tiket)
                                $("#searchDialEvent .ui-btn-text").html(texts.ManualCalcShow);
                            } else {
                                // Pridat (odd)
                                $("#searchDialEvent .ui-btn-text").html(texts.ManualCalcAdd);
                            }
                            $("#searchDialEvent").removeClass("ui-disabled");
                        } else {
                            $("#searchDialEvent").addClass("ui-disabled");
                        }
                        $("#searchDial #displayDial").removeClass("not-more").find("#searchDisplay").text(stored.sCalcID);
                    }
                    break;

                case "check":
                    if (sets.lengthOddID.includes(stored.sCalcID.length)) {
                        // Pridanie oddu na tiket
                        ticket.ticketOddModule.ctAddOdd(stored.sCalcID);
                    } else if (stored.sCalcID.length === sets.lengthEventID) {
                        // Zobrazenie detailu zapasu
                        eventDetail.showEventDetail(stored.sCalcID);
                    } else if (stored.sCalcID.length === sets.lengthStoredTicketShortID) {
                        // Zobrazenie ulozeneho tiketu
                        ticket.retrieveSavedTicket(stored.sCalcID);
                    }
                    break;

                default:
                    if (stored.sCalcID.length < Math.max(...sets.lengthOddID)) {
                        stored.sCalcID = stored.sCalcID + String(value);
                        if (stored.sCalcID.length) {
                            $("#searchDisplay").addClass("searching");
                        }
                        if (stored.sCalcID.length === sets.lengthEventID || stored.sCalcID.length === sets.lengthStoredTicketShortID) {
                            // Zobrazit (detail zapasu, ulozeny tiket)
                            $("#searchDialEvent .ui-btn-text").html(texts.ManualCalcShow);
                        } else {
                            // Pridat (odd)
                            $("#searchDialEvent .ui-btn-text").html(texts.ManualCalcAdd);
                        }
                        if (sets.lengthOddID.includes(stored.sCalcID.length) || stored.sCalcID.length === sets.lengthEventID || stored.sCalcID.length === sets.lengthStoredTicketShortID) {
                            if (sets.lengthOddID.includes(stored.sCalcID.length)) {
                                $("#searchDial #displayDial").addClass("not-more");
                            }
                            $("#searchDialEvent").removeClass("ui-disabled");
                        } else {
                            $("#searchDialEvent").addClass("ui-disabled");
                        }
                        $("#searchDisplay").text(stored.sCalcID);
                    }
                    break;
            }
            return true;
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Otvorenie terminalu na rucne zadavanie oddu a udalosti
    showManualTicketKeypad() {
        if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu
        if (!dialog.isOpen('searchDial')) {
            clearTimeout(rfs.clearDisplay);
            rfs.clearDisplay = null;
            main.dialogOpen("searchDial");
        }
    },

    // Automaticke schovanie terminula
    clearManualDialDisplay() {
        rfs.clearDisplay = setTimeout(function () {
            $("#searchDisplay").empty();
            stored.sCalcID = "";
            rfs.clearDisplay = null;
        }, sets.searchDialClear);
    }
};
